<template>
  <transition
    name="modal-transition"
    @after-leave="$emit('closed')"
  >
    <div
      v-if="visible"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
    >
      <!-- Modal Container -->
      <div
        class="relative w-full mx-auto bg-white rounded-lg shadow-lg overflow-hidden max-h-screen overflow-y-auto animate-modalEnter"
        :class="maxSize"
      >
        <!-- Close Button -->
        <button
          @click="close"
          class="absolute top-3 right-3 text-gray-500 hover:text-gray-800 focus:outline-none focus:ring focus:ring-gray-300 rounded-full"
          aria-label="Close modal"
        >
          <font-awesome-icon icon="xmark" />
        </button>

        <!-- Slot Content -->
        <slot name="body"></slot>
      </div>
    </div>
  </transition>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  components: {
    FontAwesomeIcon,
  },
  props: {
    maxSize: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      visible: true,
    };
  },
  methods: {
    close() {
      this.visible = false;
    },
  },
};
</script>

<style scoped>
.modal-transition-enter-active {
  animation: modalEnter 0.3s ease-out forwards;
}
.modal-transition-leave-active {
  animation: modalLeave 0.2s ease-in forwards;
}
</style>
